import { Icon } from '@design-system/index'
import styled from '@emotion/styled'
import styles, { typo } from '@mathflat/common/style'
import { useEffect, useRef, useState } from 'react'
import SignaturePad from 'signature_pad'

import { _OldButton } from '@/component/atoms/Button/_OldButton'
import modalService from '@/service/modal.service'

const { colors } = styles
let sigPad: SignaturePad | null = null

type Props = {
  placeHolder: string
  sign: string | null
  onSign: (data) => void
}

const CANVAS_SIZE = {
  width: 296,
  height: 280,
}

const SignatureModal = ({ placeHolder, sign, onSign }: Props) => {
  const [sigPadData, setSigPadData] = useState<string | null>(null)
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (canvasRef.current) {
      sigPad = new SignaturePad(canvasRef.current, {
        backgroundColor: 'transparent',
        onBegin: () => {
          if (sigPad instanceof SignaturePad) {
            setSigPadData(sigPad.toDataURL()) // data:image/png;base64,iVBORw0K...
          }
        },
        onEnd: () => {
          if (sigPad instanceof SignaturePad) {
            setSigPadData(sigPad.toDataURL()) // data:image/png;base64,iVBORw0K...
          }
        },
      })
      if (sign) {
        sigPad.fromDataURL(sign, { width: CANVAS_SIZE.width, height: CANVAS_SIZE.height })
        setSigPadData(sign)
      }
    }
  }, [canvasRef.current])

  const onReset = () => {
    if (sigPad) {
      sigPad.clear()
      setSigPadData(null)
    }
  }

  return (
    <S.SignatureModal>
      <S.SignPad>
        <p className="guide">
          {placeHolder} 이름 작성
          <br />
          (정자로 작성해주세요)
        </p>
        <canvas width={CANVAS_SIZE.width} height={CANVAS_SIZE.height} ref={canvasRef} />
      </S.SignPad>
      <div className="button-wrappers">
        <_OldButton theme="individual" onClick={onReset} style={{ color: colors.gray.$600 }}>
          <Icon name="erase_v2" color={'transparent'} style={{ marginRight: 6 }} />
          모두 지우기
        </_OldButton>
        <_OldButton
          theme="primary"
          onClick={() => {
            modalService.closeModal()
            onSign(sigPadData)
          }}
        >
          확인
        </_OldButton>
      </div>
    </S.SignatureModal>
  )
}

const S = {
  SignatureModal: styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    width: 344px;
    height: 380px;
    background-color: ${colors.gray.$200};
    .button-wrappers {
      display: flex;
      margin-top: 12px;

      button + button {
        margin-left: 12px;
      }
    }
  `,
  SignPad: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: white;
    width: ${CANVAS_SIZE.width}px;
    height: ${CANVAS_SIZE.height}px;
    border-radius: var(--Radius-100);
    text-align: center;
    .guide {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      user-select: none;
      color: ${colors.gray.$400};
      font-weight: bold;
      ${typo.heading05};
      @media (max-width: 600px) {
        ${typo.body02};
      }
    }
    canvas {
      position: absolute;
      z-index: 2;
      border-radius: var(--Radius-100);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `,
}
export default SignatureModal
